import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {
   SortingState,
   IntegratedSorting,
   PagingState,
   IntegratedPaging,
   SearchState,
   IntegratedFiltering
 } from '@devexpress/dx-react-grid';
import {
  Grid,
  Table,
  TableHeaderRow,
  //PagingPanel,
  SearchPanel,
  Toolbar,
  TableColumnReordering,
  DragDropProvider,
  TableColumnVisibility,
  ColumnChooser
} from '@devexpress/dx-react-grid-bootstrap4';
import {
  PagingPanel
} from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
var styles=require('./Report.less');
import {DropdownButton, MenuItem, Button} from 'react-bootstrap';
import * as commonActions from './../../actions/commonActions';
import * as reportActions from './../../actions/reportActions';
import {getPath} from './../../actions/commonActions';
import moment from 'moment';
// import '../../theme/styles/daterangepicker.css';
// import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../../theme/styles/bootstraptable.css';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import '../../theme/styles/mediaqueries.css';
import Modal from 'react-modal';
import * as filesaver from './../../actions/FileSaver';
import config from './../../config.js';
import {DcoDropdown} from './../../components/UI/Dropdown/Dropdown';
import i18next from 'i18next';
import { applyStyle,getCountofTableRows,applyToHover,setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import DateSelector from './../DateSelector/DateSelector';
import {getSelectedDate} from './../../utils/utils'; //import
const elementsData = [
  {"classNames":"filterBar", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"orderhistorytbl", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"glyphicon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons","elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell","elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"dx-g-bs4-table-cell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"noDataCell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"rptModalHeader","elementType":"noraml", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
];
const directionData = [
  {"classNames":"ordHistDrpdown","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"exportfileBaracc", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"accfilterItem", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"orderhistorytbl", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"}
];
import ReactExport from "react-data-export";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let defAccFlag = true;

@connect(state => ({
  reportData: state.dashboardRoot.reportReducer.reportData,
  //reportPageSize: state.dashboardRoot.reportReducer.reportPageSize,
  socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
  defAcc: state.dashboardRoot.dashboardReducer.defAcc,
  ACD: state.auth.ACD,
  DFA: state.auth.DFA,
  DCO:state.dashboardRoot.instrumentListReducer.DCO,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  openCalender: state.dashboardRoot.commonReducer.openCalender,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language
}), {
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    showPreview: PropTypes.object,
    loadReport: PropTypes.func.isRequired,
    reportData: PropTypes.object,
    //reportPageSize: PropTypes.string,
    getExportedReport: PropTypes.func,
    socketDataStatic: PropTypes.array,
    generateOHRPdf:PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    openCalender:PropTypes.boolean,
    onClickCalender:PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      // fromDate: '',
      // toDate: '',
      exportFormat: 'null',
      filterType: '',
      type: '',
      filterValue: '',
      ordDateOpt: 'docDate',
      ordfilter_opt: 'none',
      ac_CodeOpt: '',
      actiontype_opt: 'placed',
      cmdty_opt: 'All Pairs',
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      Dco: [],
      CmdtyPairdata: [],
      doc: '',
      docErrorMsg:'',
      showRptDialog: false,
      loadtableflag :true,
      isClearOrdHistory:false,
      isRefreshDisabled:  true,
      ranges: {
        [i18next.t('today')]: [
          moment(), moment()
        ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
      filter_opt:'',
      actionType:'',
      pageSizes: [10, 15, 20, 0],
      searchValue:'',
      HiddenActionTypeCol:[],
      HiddenFilledCol:[],
      HiddenCancelledCol:[],
      accountList:Array.from(this.props.ACD.values()),
      validationFlag:false,
      id:'today',
      keyValue:'orderHistoryReport',
      reportsRowsCount:0,
      allTableColumns:["docno","acc_desc","ORDRMK","usr","event_type","event_time","remarks"],
      modifyCancleTableColumns:["docno","acc_desc","ORDRMK","usr","event_type","event_time","remarks"],
      fillExpTableColumns:["docno","acc_desc","ORDRMK","usr","event_type","event_time","remarks"]
    }
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeHiddenActionTypeCol = this.onChangeHiddenActionTypeCol.bind(this);
    this.onChangeHiddenCancelledCol = this.onChangeHiddenCancelledCol.bind(this);
    this.onChangeHiddenFilledCol = this.onChangeHiddenFilledCol.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    window.handleSubmit = this.handleSubmit.bind(this);
    this.setState({type: 'D'});
    this.setState({ordDateOpt: 'docDate'});
    this.setState({ordfilter_opt: 'none'});
    this.setState({filterType: 'None'});
    this.setState({filterValue: 'None'});
    this.setState({filter_opt:'none'});
    this.setState({actionType:'A'});

    //const Dco = this.props.DCO;
    //let cmdtyId;
    // var dcoOrderhistory = [];
    let obj1 = {
      cmdtyId: 'All',
      cmdty: 'All Pairs'
    };
    var obj=this.props.DCO;
    for (var i = 0; i < obj.length; i++) {
      var index = obj[i].cmdtDesc.indexOf('All Pairs');
      if (index > -1) {
        obj.splice(index, 1);
      }
    }
  //  obj.unshift(obj1);
    // for (let index = 0; index < this.props.socketDataStatic.length; index++) {
    //   const cmdty = this.props.socketDataStatic[index].I;
    //   const cmdtyDes = this.props.socketDataStatic[index].ID;
    //   if (Dco.indexOf(this.props.socketDataStatic[index].I) !== -1) {
    //     let obj = {
    //       cmdtyId: cmdty,
    //       cmdty: cmdtyDes
    //     }
    //     dcoOrderhistory.unshift(obj);
    //   }
    // }
    this.setState({CmdtyPairdata: obj});

  }
  componentWillMount() {
  const locale = locale;
  this.setState({
    locale: {
        'format': 'DD-MM-YYYY',
         applyLabel: i18next.t('apply'),
         cancelLabel: i18next.t('cancel'),
         customRangeLabel:  i18next.t('customRange'),
         daysOfWeek: [
           i18next.t("su"),i18next.t("mo"),i18next.t("tu"),i18next.t("we"),i18next.t("th"),i18next.t("fr"),i18next.t("sa")
         ],
         monthNames:[
           i18next.t("jan"),i18next.t("feb"),i18next.t("mar"),i18next.t("apr"),i18next.t("may"),i18next.t("jun"),i18next.t("jul"),  i18next.t("aug"),i18next.t("sep"),i18next.t("oct"),i18next.t("nov"),i18next.t("dec")
       ]
    },
      });
 }
  componentDidUpdate(preProps){
    // if(preProps.reportData!==this.props.reportData)
    // this.refs.orderhistoryTable.reset();
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
   }
  handleSubmit = () => {
    try{
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled : true });
      let flag= 0;
      if(this.state.doc.trim() =='' && this.state.ordfilter_opt =='docNo'){
        this.props.resetStateReportData();
        this.setState({docErrorMsg:i18next.t("docNoNotEmptyMsg")});
        flag= 1;
      }else{
        this.setState({docErrorMsg:""});
        flag= 0;
      }
      this.setState({filter_opt:this.state.ordfilter_opt});
      this.setState({actionType:this.state.filterValue});

      if(flag === 0){
        this.props.loadReport(this.state.type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.filterType, this.state.filterValue);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleSubmit', component:"OrderHistoryReport"});
    }
  }
  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"OrderHistoryReport"});
    }
  }

  handleEvent = (event, picker) => {
    try{
      this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvent', component:"OrderHistoryReport"});
    }
  }

  ordDateOpt = (text, type) => {
    try{
      this.setState({ordDateOpt: text});
      this.setState({type: type});
      this.setState({ loadtableflag: true });
      this.props.loadReport(type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.filterType, this.state.filterValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'ordDateOpt', component:"OrderHistoryReport"});
    }
  }
  ordfilter_opt = (text, filterType) => {
    try{
      this.setState({docErrorMsg:""});
      this.setState({ordfilter_opt: text});
      this.setState({filter_opt:text});
      this.setState({filterType: filterType});
      //const accountList = Array.from(this.props.ACD.values());
      var filterValue=this.state.filterValue;
      if (filterType === 'acccode') {
        this.setState({doc:""});
        this.setState({ac_CodeOpt: this.props.DFA.D});
        this.setState({filterValue: this.props.DFA.C});
        filterValue=this.props.DFA.C;
      }
      if (filterType === 'none') {
        this.setState({doc:""});
        this.setState({filterValue: 'None'});
        filterValue='None';
      }
      if (filterType === 'action') {
        this.setState({doc:""});
        this.setState({filterValue: 'A'});
        filterValue='A';
        this.setState({actiontype_opt:i18next.t("placed")});
      }
      const Dco = this.props.DCO;
      if (filterType === 'Cmdty') {
        this.setState({doc:""});
        this.setState({filterValue: this.state.CmdtyPairdata[0].cmdtId});
        filterValue=this.state.CmdtyPairdata[0].cmdtId;
        this.setState({cmdty_opt: this.state.CmdtyPairdata[0].cmdtDesc});
      }
      this.setState({actionType:filterValue});
      this.setState({actiontype_opt:i18next.t("placed")});
      if(filterValue !== 'DocNo'){
        this.setState({ loadtableflag: true });
        this.props.loadReport(this.state.type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), filterType, filterValue);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'ordfilter_opt', component:"OrderHistoryReport"});
    }
  }
  componentWillReceiveProps(nextProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //       {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
    //       {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if(this.state.isClearOrdHistory !== this.props.isClearOrdHistory){
      this.setState({ isClearOrdHistory: true });
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled : true });
      this.setState({type: 'D'});
      this.setState({ordDateOpt: 'docDate'});
      this.setState({ordfilter_opt: 'none'});
      this.setState({filterType: 'None'});
      this.setState({filterValue: 'None'});
      this.setState({filter_opt:'none'});
      this.setState({actionType:'A'});
      this.setState({docErrorMsg:""});
      this.setState({startDate: new Date().toLocaleDateString('en-US')});
      this.setState({endDate:new Date().toLocaleDateString('en-US')});
      this.setState({currentDate: new Date().toLocaleDateString('en-US')});
      this.setState({id:'today'});
    }
    if(nextProps.reportData !== this.props.reportData){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
      this.setState({ reportsRowsCount : nextProps.reportData.length });
    }
    if(nextProps.defAcc !== this.props.defAcc){
        this.setState({ac_CodeOpt: nextProps.defAcc.AD});
        this.setState({filterValue:nextProps.defAcc.AC});
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
  }

  setStartDate = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"OrderHistoryReport"});
    }
  }
  setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"OrderHistoryReport"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"OrderHistoryReport"});
    }
  }
  
  ac_CodeOpt = (filterText, filterValue) => {
    try {
        this.setState({ac_CodeOpt: filterText});
        this.setState({filterValue: filterValue});
        if (this.props.DFA.C !== filterValue) {
          defAccFlag = false;
          this.setState({AccFlag: false});
          // this.chnageAccPos(filterValue);
          //this.setState(defAccFlag:false);
        } else {
          defAccFlag = true;
          this.setState({AccFlag: true});
        }
      this.setState({ loadtableflag: true });
      this.props.loadReport(this.state.type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.filterType, filterValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'ac_CodeOpt', component:"OrderHistoryReport"});
    }
  }
  docno_opt = (event) => {
    try{
      this.setState({filterValue: event.target.value});
      this.setState({doc: event.target.value});
      // if(event.target.value =='' && this.state.ordfilter_opt =='Doc No'){
      //   this.props.resetStateReportData();
      //   this.setState({docErrorMsg:"Document number cannot be empty"});
      // }else{
      //   this.setState({docErrorMsg:""});
      //   this.setState({ loadtableflag: true });
      //   const startDate =  moment(this.state.startDate).format('DD-MM-YYYY');
      //   const endDate =  moment(this.state.endDate).format('DD-MM-YYYY');
      //   this.props.loadReport(this.state.type,startDate,endDate, this.state.filterType,event.target.value);
      // }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'docno_opt', component:"OrderHistoryReport"});
    }
  }
  onKeyPress = (event) => {
    try{
      if (event.which === 13 /* Enter */) {
        this.setState({filterValue: event.target.value});
        this.setState({doc: event.target.value});
        if(event.target.value.trim() =='' && this.state.ordfilter_opt =='docNo'){
          this.props.resetStateReportData();
          this.setState({docErrorMsg:"Document number cannot be empty"});
        }
        else if(!event.target.value.charAt(0).match(/^[0-9a-zA-Z]+$/)){
          this.props.resetStateReportData();
          this.setState({docErrorMsg:"Please enter valid document number."});
        }
        else{
          this.setState({docErrorMsg:""});
          this.setState({ loadtableflag: true });
          const startDate =  moment(this.state.startDate).format('DD-MM-YYYY');
          const endDate =  moment(this.state.endDate).format('DD-MM-YYYY');
          this.props.loadReport(this.state.type,startDate,endDate, this.state.filterType,event.target.value);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onKeyPress', component:"OrderHistoryReport"});
    }
  }
  onBlurDocNo = (event) => {
    try{
      this.setState({filterValue: event.target.value});
      this.setState({doc: event.target.value});
      if(event.target.value.trim() =='' && this.state.ordfilter_opt =='docNo'){
        this.props.resetStateReportData();
        this.setState({docErrorMsg:"Document number cannot be empty"});
      }
      else if(!event.target.value.charAt(0).match(/^[0-9a-zA-Z]+$/)){
        this.props.resetStateReportData();
        this.setState({docErrorMsg:"Please enter valid document number."});
      }
        else{
        this.setState({docErrorMsg:""});
        this.setState({ loadtableflag: true });
        const startDate =  moment(this.state.startDate).format('DD-MM-YYYY');
        const endDate =  moment(this.state.endDate).format('DD-MM-YYYY');
        this.props.loadReport(this.state.type,startDate,endDate, this.state.filterType,event.target.value);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurDocNo', component:"OrderHistoryReport"});
    }
  }
  actiontype_opt = (text, actionSubFilter) => {
    try{
      this.setState({actiontype_opt: text});
      this.setState({filterValue: actionSubFilter});
      this.setState({ loadtableflag: true });
      this.setState({actionType:actionSubFilter});
      this.props.loadReport(this.state.type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.filterType, actionSubFilter);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'actiontype_opt', component:"OrderHistoryReport"});
    }
  }
  cmdty_opt = (filterValue, filterText) => {
    try{
      this.setState({cmdty_opt: filterText});
      this.setState({filterValue: filterValue});
      this.setState({ loadtableflag: true });
      this.props.loadReport(this.state.type, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.filterType, filterValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cmdty_opt', component:"OrderHistoryReport"});
    }
  }

  changeFlag = () => {
    try{
     this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"OrderHistoryReport"});
   }
  }
  
  generatePdf=(format)=>{
    try{
      const user = JSON.parse(localStorage.getItem('user'));
      const platform = localStorage.getItem('platform');
      const type = this.state.type;
      const startDate = moment(this.state.startDate).format('DD-MM-YYYY');
      const endDate = moment(this.state.endDate).format('DD-MM-YYYY');
      const filterType = this.state.filterType;
      const filterValue = this.state.filterValue;
      let response = '';
      var xhr = new XMLHttpRequest();
      if(this.props.reportData.length === 0 || this.props.reportData === '' || this.props.reportData === null){
        this.changeFlag();
      } else{
      if (format === 'PDF') {
        xhr.open('GET',getPath("api") + '/user/export_OrderHistory_pdf?startDate='+startDate+'&endDate='+endDate+'&type='+type+'&filterType='+filterType+'&filterValue='+filterValue+'&timezone='+Intl.DateTimeFormat().resolvedOptions().timeZone, true);
        xhr.setRequestHeader('x-auth', user.authToken);
        xhr.setRequestHeader('username', user.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('platform',platform);
        xhr.setRequestHeader('userCode',user.UD);
        xhr.setRequestHeader('SID',user.SID);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
          if(xhr.status === 200){
              filesaver.saveAs(xhr.response, "Order_History_Report_" + startDate + "_to_" + endDate + ".pdf");
          }else{
            //this.changeFlag();
          }
        }.bind(this);
        xhr.send();
      } else {
        xhr.open('GET',config.apiPath + '/user/export_OrderHistory_xls?startDate='+startDate+'&endDate='+endDate+'&type='+type+'&filterType='+filterType+'&filterValue='+filterValue, true);
        xhr.setRequestHeader('x-auth', user.authToken);
        xhr.setRequestHeader('username', user.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('platform',platform);
        xhr.setRequestHeader('userCode',user.UD);
        xhr.setRequestHeader('SID',user.SID);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
          if(xhr.status === 200){
              filesaver.saveAs(xhr.response, "Order_History_Report_" + startDate + "_to_" + endDate +".xlsx");
          }else{
            this.changeFlag();
          }
        }.bind(this);
        xhr.send();
      }
    }
      //this.props.generateOHRPdf(this.state.type, this.state.startDate, this.state.endDate, this.state.filterType, this.state.filterValue,format);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"OrderHistoryReport"});
    }
  }
  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      var count=this.state.filter_opt !=='Action Type' || this.state.actionType==='A' ?getCountofTableRows(this.props.reportData,this.state.allTableColumns,value)
      :this.state.actionType==='M' || this.state.actionType==='C' ?getCountofTableRows(this.props.reportData,this.state.modifyCancleTableColumns,value)
      :getCountofTableRows(this.props.reportData,this.state.fillExpTableColumns,value);
      this.setState({reportsRowsCount: count });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"OrderHistoryReport"});
    }
  }
  onChangeHiddenActionTypeCol(hiddenCol){
    try{
      this.setState({ HiddenActionTypeCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenActionTypeCol', component:"OrderHistoryReport"});
    }
  };
  onChangeHiddenCancelledCol(hiddenCol){
    try{
      this.setState({ HiddenCancelledCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenCancelledCol', component:"OrderHistoryReport"});
    }
  };
  onChangeHiddenFilledCol(hiddenCol){
    try{
      this.setState({ HiddenFilledCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenFilledCol', component:"OrderHistoryReport"});
    }
  };
  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"OrderHistoryReport"});
    }
   }

  render() {
    const dropDownListColor =theme =>({
          dropDownListHoverMenu:{
            '& .dropdown-item':{
                // background:this.props.selectedCssColorTheme.dropDownList.background,
                // color:this.props.selectedCssColorTheme.dropDownList.color
              },
              '& :hover':{
                // background:this.props.selectedCssColorTheme.dropDownListHover.background,
                // color:this.props.selectedCssColorTheme.dropDownListHover.color
              }
          }
        });

    const ContainerColor = ({ classes, ...restProps }) => (
          <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
        );
       const MenuColor = props => (
           <ColumnChooser.Item {...props} />
     );
    const {type,filterType,filterValue,startDate,endDate,CmdtyPairdata,filter_opt,actionType} = this.state;
    const {exportFormat,ordDateOpt,ordfilter_opt,cmdty_opt,actiontype_opt,ac_CodeOpt,docno_opt} = this.state;
    const start = this.state.startDate;
    const end = this.state.endDate;
    let label = start + ' - ' + end;
    if (start === end) {
      label = start;
    }
    const Acols = [
      {name:'docno',title:i18next.t('orderNo'), width: {wpx: 160} },
      {name:'acc_desc',title:i18next.t('account'), width: {wpx: 150} },
      {name:'ORDRMK',title:i18next.t('orderDetails'), width: {wpx: 150} },
      {name:'usr',title:i18next.t('user'), width: {wpx: 110} },
      {name:'event_type',title:i18next.t('action'), width: {wpx: 110} },
      {name:'event_time',title:i18next.t('eventTime'), width: {wpx: 200} },
      {name:'remarks',title:i18next.t('comments'), width: {wpx: 400} }
    ];
    const Ccols = [
      {name:'docno',title:i18next.t('orderNo'), width: {wpx: 160} },
      {name:'acc_desc',title:i18next.t('account'), width: {wpx: 150} },
      {name:'ORDRMK',title:i18next.t('orderDetails'), width: {wpx: 150} },
      {name:'usr',title:i18next.t('user'), width: {wpx: 110} },
      {name:'event_type',title:i18next.t('action'), width: {wpx: 110} },
      {name:'event_time',title:i18next.t('eventTime'), width: {wpx: 200} },
      {name:'remarks',title:i18next.t('comments'), width: {wpx: 400} }
    ];
    const Ecols = [
      {name:'docno',title:i18next.t('orderNo'), width: {wpx: 160} },
      {name:'acc_desc',title:i18next.t('account'), width: {wpx: 150} },
      {name:'ORDRMK',title:i18next.t('orderDetails'), width: {wpx: 150} },
      {name:'usr',title:i18next.t('user'), width: {wpx: 110} },
      {name:'event_type',title:i18next.t('action'), width: {wpx: 110} },
      {name:'event_time',title:i18next.t('eventTime'), width: {wpx: 200} },
      {name:'remarks',title:i18next.t('comments'), width: {wpx: 400} }
    ];
    var tableData1 = [];
    var tableData2 = [];
    var tableData3 = [];
    var propData = this.props.reportData;

    for(let i=0;i<propData.length;i++){
       tableData1[i] =
       [{value: propData[i].docno, style: {alignment: {horizontal:"left"}}},
       {value: propData[i].acc_desc, style: {alignment: {wrapText: true,horizontal:"left"}}},
       {value: propData[i].ORDRMK, style: {alignment: {wrapText: true,horizontal:"left"}}},
       {value: propData[i].usr, style: {alignment: {wrapText: true,horizontal:"left"}}},
       {value: propData[i].event_type, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
       {value: propData[i].event_time, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
       {value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

       tableData2[i] =  [{value: propData[i].docno, style: {alignment: {horizontal:"left"}}},
        {value: propData[i].acc_desc, style: {alignment: {wrapText: true,horizontal:"left"}}},
        {value: propData[i].ORDRMK, style: {alignment: {wrapText: true,horizontal:"left"}}},
        {value: propData[i].usr, style: {alignment: {wrapText: true,horizontal:"left"}}},
        {value: propData[i].event_type, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
        {value: propData[i].event_time, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
        {value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

        tableData3[i] = [{value: propData[i].docno, style: {alignment: {horizontal:"left"}}},
         {value: propData[i].acc_desc, style: {alignment: {wrapText: true,horizontal:"left"}}},
         {value: propData[i].ORDRMK, style: {alignment: {wrapText: true,horizontal:"left"}}},
         {value: propData[i].usr, style: {alignment: {wrapText: true,horizontal:"left"}}},
         {value: propData[i].event_type, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
         {value: propData[i].event_time, style: {alignment: {wrapText: true,horizontal:"left"}}} ,
         {value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}]

     }
    
    let multiDataSet1 = [
      {
        columns: Acols,
        data: tableData1
      }
    ];
    let multiDataSet2 = [
      {
        columns: Ccols,
        data: tableData2
      }
    ];
    let multiDataSet3 = [
      {
        columns: Ecols,
        data: tableData3
      }
    ];
    const pagingPanelMessages = {
      showAll: i18next.t('all'),
      rowsPerPage: i18next.t('rowsPerPage'),
      info:'',
    };
    const searchPlaceholderMsg = {
      searchPlaceholder: i18next.t('search')+'...',
    };
    const PagingContainer = props => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = props => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark"  />
    );

    const Dco = this.props.DCO;
    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead th': {
          //color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          //color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });
    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} id="ordHistRptTable" className={classes.tableStriped}/>
    );
    var NoDataMsg = {
      noData: '',
    }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    }
    else {
      NoDataMsg.noData = i18next.t('noDataAvlMsg');
    }
    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell" />
    );
    const Cell = props => {
      const { column } = props;
      if(column.name === "event_time"){
          return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      return <Table.Cell {...props} />;
    };
    return (
      <div id="ordHistRptDiv" className={`${this.props.language}`}>
        <Modal isOpen={this.state.validationFlag} id="ordHistDatevalModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" style={this.props.selectedCssColorTheme.mdlWrap}>
            <div className={`${styles.header} rptModalHeader header`} style={this.props.selectedCssColorTheme.rptModalHeader}>Error
              <span onClick={this.closeValidationModal} className={`${styles.closeImg} closeIcon`}>{this.props.closeIcon}</span>
            </div>
            <div className={`${styles.msg} commonMsgDir`} >
              <h4>{i18next.t("dateSelectorErrMsg")}</h4>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.showRptDialog} className={styles.warningModal} id="orlHistModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} rptModalHeader header`} >
              <span className={`${styles.msgTitle}`}>{i18next.t('ordHistRpt')}</span>
              <span onClick={this.closeRptModal} className={`${styles.closeImg} closeIcon`} id="orlHistCloseIcon">{this.props.closeIcon}</span>
            </div>
            <div className={`${styles.msg} commonMsgDir`} style={this.props.selectedCssColorTheme.rptModalMsg}>
              {i18next.t('noDataAvlMsg')}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
                <Button className='button-l' bsStyle="primary" onClick={this.closeRptModal} id="orlHistCloseBtn" >{i18next.t('OK')}</Button>
            </div>
          </div>
        </Modal>
        <div id="ordHistRptFilter" className={`${styles.filterBar} filterBar ordhistoryfilterBar ${this.props.selectedCssColor}`}>
          <div className={`${styles.filterBarInner} fltrBarInner`}>
            <div className={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`} id="orderHistorydatetype">
              <DropdownButton title={i18next.t(ordDateOpt)} id="bg-nested-dropdown" className="reportsDropdown btnText">
                <MenuItem onClick={() => this.ordDateOpt('docDate', "D")}>{i18next.t('docDate')}</MenuItem>
                <MenuItem onClick={() => this.ordDateOpt('eventDate', "E")}>{i18next.t('eventDate')}</MenuItem>
              </DropdownButton>
            </div>
            <div className={`${styles.selectDatebtn} ordHistDrpdown`} id="trdOnlOrdrptDate">
              <DateSelector
                keyValue={this.state.keyValue}
                onClickFilter={this.handleSubmit}
                setStartDate={this.setStartDate}
                setEndDate={this.setEndDate}
                component='Report'
              />
            </div>
            <div className={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`} id="orderHistoryfilter" >
              <DropdownButton title={i18next.t(ordfilter_opt)} id="bg-nested-dropdown" className="reportsDropdown btnText">
                <MenuItem onClick={() => this.ordfilter_opt('none', "none")} id="orlHistFiltrNone">{i18next.t('none')}</MenuItem>
                <MenuItem onClick={() => this.ordfilter_opt('accCode', "acccode")} id="orlHistFiltrAccCode">{i18next.t('accCode')}</MenuItem>
                <MenuItem onClick={() => this.ordfilter_opt('docNo', "DocNo")} id="orlHistFiltrDocNo">{i18next.t('docNo')}</MenuItem>
                <MenuItem onClick={() => this.ordfilter_opt('actionType', "action")} id="orlHistFiltrAction">{i18next.t('actionType')}</MenuItem>
                <MenuItem onClick={() => this.ordfilter_opt('pair', "Cmdty")} id="orlHistFiltrPair">{i18next.t('pair')}</MenuItem>
              </DropdownButton>
            </div>
            {filterType === 'acccode'
              ? <div className={`${styles.filterItemAcc} ordHistDrpdown`} id="orderhistoryAcNo">
                  <DropdownButton title={ac_CodeOpt} id="bg-nested-dropdown" className={`${styles.orderHistoryAccount} btnText`} >
                    {this.state.accountList.map((item) => {
                      return (
                        <MenuItem onClick={() => this.ac_CodeOpt(item.D, item.C)} id="orlHistAccCodeMenu" >{item.D}</MenuItem>
                      );
                    })
  }
                  </DropdownButton>
                </div>
              : null}
            {filterType === 'DocNo'
              ? <div className={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`} id="orderhistoryDocNo">
                  <input type="text" title={docno_opt} onBlur={this.onBlurDocNo} onKeyPress={this.onKeyPress} onChange={this.docno_opt} id="orlHistInputDocNo" />
                </div>
              : null}
            {this.state.docErrorMsg != '' ? <p className={styles.orderhistoryDocNoError}>{this.state.docErrorMsg}</p> : null}
            {filterType === 'action'
              ? <div className={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`} id="ordhistorysubopt">
                  <DropdownButton title={i18next.t(actiontype_opt)} id="bg-nested-dropdown" className="reportsDropdown btnText" >
                    <MenuItem onClick={() => this.actiontype_opt('placed', "A")} id="ordHistActnPlaced" >{i18next.t('placed')}</MenuItem>   {/* Add  renamed to placed */}
                    <MenuItem onClick={() => this.actiontype_opt('modified', "M")} id="ordHistActnModified" >{i18next.t('modified')}</MenuItem>
                    <MenuItem onClick={() => this.actiontype_opt('cancelled', "C")} id="ordHistActnCancelled" >{i18next.t('cancelled')}</MenuItem>
                    <MenuItem onClick={() => this.actiontype_opt('filled', "F")} id="ordHistActnFilled" >{i18next.t('filled')}</MenuItem>
                    <MenuItem onClick={() => this.actiontype_opt('expired', "E")} id="ordHistActnExpired" >{i18next.t('expired')}</MenuItem>
                  </DropdownButton>
                </div>
              : null}
            {filterType === 'Cmdty'
              ? <DcoDropdown
                  parentDivClassname={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`}
                  parentDivId="ordhistorysubopt"
                  dropdownTitle={i18next.t(cmdty_opt)}
                  dropdownId="bg-nested-dropdown"
                  dropdownData={this.state.CmdtyPairdata}
                  dataItemClick={this.cmdty_opt}
                  className="reportsDropdown"
                  dropdown
                  menu
                />
              : null}
            <div className={`${styles.exportfileBaracc} exportfileBaracc`} id="orderhistoryfiledownload">
              {/* <div className={styles.accfilterItem} id="ordhistorygobtn">
              <button type="button" className={styles.goBtn} onClick={() => this.handleSubmit(type, startDate, endDate, filterType, filterValue)}>Refresh</button>
            </div> */}
            <div id="ordhistorygobtn" className="accfilterItem">
            <button type="button" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}`} onClick={() => this.handleSubmit()} id="ordHistRefreshBtn">
              {this.props.refreshIcon}
            </button>
          </div>
              <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                {(this.props.reportData.length!==0) && <span><ExcelFile  filename="OrderHistoryReport" element={(<img src="/images/xls.png"/>)}>
                    {(filter_opt !=='Action Type' || actionType==='A') ? <ExcelSheet dataSet={multiDataSet1} name="OrderHistoryReport" />
                     :
                     (actionType==='M' || actionType==='C') ? <ExcelSheet dataSet={multiDataSet2} name="OrderHistoryReport" />
                     :
                     (actionType==='F' || actionType==='E') ? <ExcelSheet dataSet={multiDataSet3} name="OrderHistoryReport" />
                     :null}
                </ExcelFile>
                    </span>}
                {(this.props.reportData.length===0) && <img src="/images/xls.png" onClick={this.changeFlag}/>}
                <span><img src="/images/pdf.png" onClick={()=>{this.generatePdf("PDF")}} id="ordHistPDF"/></span>
              </label>
            </div>
          </div>
        </div>
        <div className={`${styles.orderhistorytbl} orderhistorytbl`} id="orderhistorytbl">
          {this.state.loadtableflag === true ?
            <div className={styles.rptoverlay} >
                <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          : null}
            {filter_opt !=='actionType' || actionType==='A' ?
            <div className={`${styles.orderhistoryActionTable} reportsTblGrid`} >
              <Grid rows={this.props.reportData}  columns={Acols}>
                <SortingState/>
                <IntegratedSorting />
                {this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10} />
                :null}
                {this.state.reportsRowsCount>10?<IntegratedPaging />
                :null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
                <IntegratedFiltering />
                <Table cellComponent={Cell} tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenActionTypeCol} onHiddenColumnNamesChange={this.onChangeHiddenActionTypeCol}/>
                {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
                :
                this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
                <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
                :null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autocomplete="new-password"/>
                  <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
            // <BootstrapTable data={this.props.reportData} ref="orderhistoryTable" version='4' pagination={true} id={styles.orderHistory} options={options}>
            //   <TableHeaderColumn dataField='event_time' width="16%"  dataSort className="eventTime">{i18next.t('Event Time')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='event_type' width="8.5%" dataSort className="action">{i18next.t('Action')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='usr' width="10%" dataSort className="user">{i18next.t('User')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='acc_desc' width="15%" dataSort className="account">{i18next.t('Account')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='deal_type' width="8%" dataSort className="deal">{i18next.t('Deal')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='docno' width="14%" isKey dataSort>{i18next.t('Doc #')}</TableHeaderColumn>
            //   <TableHeaderColumn dataField='remarks'>{i18next.t('Comments')}</TableHeaderColumn>
            // </BootstrapTable>
          :null}
          {actionType==='M' || actionType==='C' ?
          // <BootstrapTable data={this.props.reportData} ref="orderhistoryTable" version='4' pagination={true} id={styles.orderHistory} options={options}>
          //   <TableHeaderColumn dataField='event_time' width="16%"  dataSort className="eventTime">{i18next.t('Event Time')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='event_type' width="10%" dataSort className="action">{i18next.t('Action')}</TableHeaderColumn>
          //    <TableHeaderColumn dataField='usr' width="10%" dataSort className="user">{i18next.t('User')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='acc_desc' width="15%" dataSort className="account">{i18next.t('Account')}></TableHeaderColumn>
          //   {/* <TableHeaderColumn dataField='deal_type' width="5%" dataSort className="deal">Deal</TableHeaderColumn> */}
          //   <TableHeaderColumn dataField='docno' width="14%" isKey dataSort>{i18next.t('Doc #')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='remarks'>{i18next.t('Comments')}</TableHeaderColumn>
          // </BootstrapTable>
          <div className={`${styles.orderhistoryMCTable} reportsTblGrid`} >
            <Grid rows={this.props.reportData}  columns={Ccols}>
              <SortingState/>
              <IntegratedSorting />
              {this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10}/>
              :null}
              {this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
              <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
              <IntegratedFiltering />
              <Table cellComponent={Cell} tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
              <TableHeaderRow showSortingControls />
              <TableColumnVisibility hiddenColumnNames={this.state.HiddenCancelledCol} onHiddenColumnNamesChange={this.onChangeHiddenCancelledCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
              <Toolbar />
              <SearchPanel messages={searchPlaceholderMsg} autocomplete="new-password"/>
              <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
            </Grid>
          </div>
          :null}
           {actionType==='F' || actionType==='E' ?
          // <BootstrapTable data={this.props.reportData} ref="orderhistoryTable" version='4' pagination={true} id={styles.orderHistory} options={options}>
          //   <TableHeaderColumn dataField='event_time' width="16%"  dataSort className="eventTime">{i18next.t('Event Time')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='event_type' width="10%" dataSort className="action">{i18next.t('Action')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='acc_desc' width="15%" dataSort className="account">{i18next.t('Account')}</TableHeaderColumn>
          //   <TableHeaderColumn dataField='docno' width="14%" isKey dataSort>{i18next.t('Doc #')}></TableHeaderColumn>
          //   <TableHeaderColumn dataField='remarks'>{i18next.t('Comments')}</TableHeaderColumn>
          // </BootstrapTable>
          <div className={`${styles.orderhistoryFETable} reportsTblGrid`} >
            <Grid rows={this.props.reportData}  columns={Ecols}>
              <SortingState/>
              <IntegratedSorting />
              {this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10} />
              :null}
              {this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
              <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
              <IntegratedFiltering />
              <Table cellComponent={Cell} tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
              <TableHeaderRow showSortingControls />
              <TableColumnVisibility hiddenColumnNames={this.state.HiddenFilledCol} onHiddenColumnNamesChange={this.onChangeHiddenFilledCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
              <Toolbar />
              <SearchPanel messages={searchPlaceholderMsg} autocomplete="new-password"/>
              <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
            </Grid>
          </div>
         :null}

        </div>
      </div>
    );
  }
}
